import { useOffline } from '../components/App/AppOfflineContext'
import MainLayout, { useMainLayoutContext } from '../components/MainLayout'
import Tile from '../shared/components/EqxTile/EqxTile'
import TileGroup from '../shared/components/EqxTile/EqxTileGroup'

const WorkTileContent = () => {
    const { isOffline, isFileCached } = useOffline()
    const { permissions } = useMainLayoutContext()
    const disabledServiceOrders = isOffline && !isFileCached('/service-orders/today') && !isFileCached('/service-orders/future')
    const canCreateIncident = permissions?.canCreateIncident

    return (
        <TileGroup size="xs">
            <Tile
                className="col-6 col-lg-4"
                link="/service-orders"
                title="Service Orders"
                icon="fas fa-tools"
                disabled={disabledServiceOrders}
            />
            {canCreateIncident && (
                <Tile
                    className="col-6 col-lg-4"
                    link="/incidents/create"
                    title="Log Incident"
                    icon="fas fa-exclamation-triangle"
                    disabled={isOffline}
                />
            )}
        </TileGroup>
    )
}

interface PageWorkProps { }
const PageWork = function (props: PageWorkProps) {
    return (
        <MainLayout pageTitle="Work">
            <WorkTileContent />
        </MainLayout>
    )
}

export { PageWork as default }
